import { extend, override } from 'flarum/extend';
import HeaderSecondary from 'flarum/components/HeaderSecondary';
import HeaderPrimary from 'flarum/components/HeaderPrimary';
import ItemList from 'flarum/utils/ItemList';

extend(HeaderSecondary.prototype, 'items', function(items) {
  items.remove('logIn');
  items.remove('locale');
  items.add('backToCourses', <a href="/">Accueil Communauté</a>);
});

override(HeaderPrimary.prototype, 'items', function(original) {
  let items = new ItemList();
  items.add('home-link', <a id="back-course" href="https://membre.myguitare.com">MyGuitare</a>);
  return items;
});
